import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Feature from 'ol/Feature';
import { Subject } from 'rxjs';
 
import { FlightInspectionCSVFields } from 'src/app/models/ImportCSV';
import { PointsService } from 'src/app/services/points.service';
import { ColorInterval, FlightInspectionStyleComponent } from '../flight-inspection-style/flight-inspection-style.component';
 
@Component({
  selector: 'app-configure-flight-inpection-format',
  templateUrl: './configure-flight-inpection-format.component.html',
  styleUrls: ['../../app.component.scss', './configure-flight-inpection-format.component.scss'],
  standalone: false
})
export class ConfigureFlightInpectionFormatComponent implements OnInit {
  activeFileConfig:boolean = true;
  activeFieldsConfig:boolean = false;
  activeSot:boolean = false;
  activeflags :boolean = false;
  activeChannel1 : boolean= false;
  activeChannel2 : boolean= false;
  activeChannel3 : boolean= false;
  activeChannel4 : boolean= false;
 
  @Input() importConfig : any;
  @Input() fieldConfigurationTable: any;
  @Input() fileFormat:string;
 
  onClose: Subject<any>;
  navaidOptions : String[] = [];
  fileConfig: FormGroup;
  constructor(
    public bsModalRef : BsModalRef,
    public popupService: BsModalService,
    public pointsService: PointsService
  ) { }
 
  ngOnInit(): void {
    this.onClose = new Subject();
 
  }
 
  close(){
    this.bsModalRef.hide();
  }
  getNavaidStringOptions(){
    if(this.navaidOptions.length == 0){
      this.pointsService.getAllNavaidsFeaturesFromLayers()
      .forEach((navaid:Feature) =>{
        this.navaidOptions.push(navaid.get('navaidid')+" - " +navaid.get('navaidtype') + " - "+ navaid.get('icaocc'))
      })
    }
    return this.navaidOptions;
  }
  validNavaid(navaid:string){
    return navaid == "TIS-VOR_DME-LF" ||this.navaidOptions.find((option) => option == navaid) != null;
  }
  validChannel(channelName:string){
    return channelName == "SIO-VOR_DME-LS" ||
    channelName == "VIT-DME-LB" ||
    channelName == "TACAN1" ||
    channelName == "TACAN2"||
    this.navaidOptions.find((option) => option == channelName) != null
  }
  validChannels(){
    for(let channel of this.importConfig.channels){
      if(channel.channelName != "SIO-VOR_DME-LS" &&
      channel.channelName != "VIT-DME-LB" &&
      channel.channelName != "TACAN1"&&
      channel.channelName != "TACAN2"&&
      this.navaidOptions.find((option) => option == channel.channelName) == null)
        return false;
    }
    return true;
  }
  activateFileConfiguration(){
    this.activeFileConfig = true;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateFieldsConfiguration(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = true;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateSot(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = true;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateFlags(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = true;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateChannel1(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = true;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateChannel2(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = true;
    this.activeChannel3 = false;
    this.activeChannel4 = false;
  }
  activateChannel3(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = true;
    this.activeChannel4 = false;
  }
  activateChannel4(){
    this.activeFileConfig = false;
    this.activeFieldsConfig = false;
    this.activeSot = false;
    this.activeflags = false;
    this.activeChannel1 = false;
    this.activeChannel2 = false;
    this.activeChannel3 = false;
    this.activeChannel4 = true;
  }
  openStyleOfField(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
 
    bsModalRef.content.title = this.importConfig.fieldsConfigurationTable[i].name + ' - '+this.importConfig.fieldsConfigurationTable[i].units;
    bsModalRef.content.colorIntervals = this.importConfig.fieldsConfigurationTable[i].style? cloneDeep(this.importConfig.fieldsConfigurationTable[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.fieldsConfigurationTable[i].style? new Array(this.importConfig.fieldsConfigurationTable[i].style.length).fill(true): [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.fieldsConfigurationTable[i].style = colorIntervals;
    })
  }
  editFlagStyle(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.tableFlags[i].flag ;
    bsModalRef.content.colorIntervals = this.importConfig.tableFlags[i].style? cloneDeep(this.importConfig.tableFlags[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.tableFlags[i].style? new Array(this.importConfig.tableFlags[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.tableFlags[i].style = colorIntervals;
    })
  }
  editSoTStyle(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.tableSoT[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.tableSoT[i].style? cloneDeep(this.importConfig.tableSoT[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.tableSoT[i].style? new Array(this.importConfig.tableSoT[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.tableSoT[i].style = colorIntervals;
    })
  }
  editChannel1Style(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.channel1[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.channel1[i].style? cloneDeep(this.importConfig.channel1[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.channel1[i].style? new Array(this.importConfig.channel1[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.channel1[i].style = colorIntervals;
    })
  }
  editChannel2Style(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.channel2[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.channel2[i].style? cloneDeep(this.importConfig.channel2[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.channel2[i].style? new Array(this.importConfig.channel2[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.channel2[i].style = colorIntervals;
    })
  }
  editChannel3Style(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.channel3[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.channel3[i].style? cloneDeep(this.importConfig.channel3[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.channel3[i].style? new Array(this.importConfig.channel3[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.channel3[i].style = colorIntervals;
    })
  }
  editChannel4Style(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.channel4[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.channel4[i].style? cloneDeep(this.importConfig.channel4[i].style) : [];
    bsModalRef.content.validIntervals = this.importConfig.channel4[i].style? new Array(this.importConfig.channel4[i].style.length).fill(true) : [];
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.channel4[i].style = colorIntervals;
    })
  }
  restoreDefault(){
    if(this.fileFormat == "CSV"){
      this.importConfig = new CSVConfiguration();
    }
    else if( this.fileFormat == "EDS"){
      this.importConfig = new EDSConfiguration();
    }
    else if(this.fileFormat == "Aerodata"){
      this.importConfig = new AerodataConfig();
    }
  }
  ok(){
    this.onClose.next(this.importConfig);
    this.bsModalRef.hide();
  }
}
export class SoTTableElem{
  constructor(public selected: boolean,
    public name: string,
    public hasStyle:boolean,
    public style: ColorInterval[] = []
    ){
 
  }
}
export class FlagsTableElem{
  constructor(public selected: boolean,
     public flag: string,
     public description,
     public hasStyle: boolean,
     public style: ColorInterval[] = []
     ){
 
  }
 
}
export class FileConfiguration{
  /*
  fieldSeparator:string = ';';
  dataStartingLine : number = 2;
  decimalSeparator : string = '.';
  thousandSeparator : string = '.';
  useThousandSeparator:boolean=false;
*/
  constructor(
    public fieldSeparator: string,
    public dataStartingLine: number,
    public decimalSeparator: string,
    public thousandSeparator: string,
    public useThousandSeparator: boolean,
    public decimate: boolean,
    public decimateSample: number
  ) {}
}
export class CSVConfiguration{
  fileConfiguration: FileConfiguration = new FileConfiguration(";",2,",",".", false,false,null);
  fieldsConfigurationTable : FlightInspectionCSVFields[] = [
    new FlightInspectionCSVFields("Navaid Identifier","Navaid Identifier","N/A","A",false ,false),
    new FlightInspectionCSVFields("A/C Latitude","A/C Latitude","[Degree]","F",false ,true),
    new FlightInspectionCSVFields("A/C Longitude","A/C Longitude","[Degree]","G",false ,true),
    new FlightInspectionCSVFields("Ground Station Latitude","Ground Station Latitude","[Degree]","B",false ),
    new FlightInspectionCSVFields("Ground Station Longitude","Ground Station Longitude","[Degree]","C",false),
    new FlightInspectionCSVFields("Altitude","Altitude","[m]","H",true ,false,true,[
      new ColorInterval(-Infinity, 3000,'#ff0000',true, false),
      new ColorInterval(3000, 6000, '#ffa500'),
      new ColorInterval(6000, 10000, '#ffff00'),
      new ColorInterval(10000, 20000, '#008000'),
      new ColorInterval(20000, Infinity, '#0000ff',false,true)
    ]),
    new FlightInspectionCSVFields("Measured Power Level","Measured Power Level","[dBm]","K",true ,false,true,[
      new ColorInterval(-Infinity,-81,'#ff0000',true,false),
      new ColorInterval(-81,-78,'#ffa500',false,false),
      new ColorInterval(-78,-75,'#ffff00',false,false),
      new ColorInterval(-75,Infinity,'#00ff00',false,true),
    ]),
    new FlightInspectionCSVFields("Estimated Power Density","Estimated Power Density","[dBm/m2]","E",true ,false,false,[
      new ColorInterval(-Infinity,-89,'#ff0000',true,false),
      new ColorInterval(-89,-86,'#ffa500',false,false),
      new ColorInterval(-86,-83,'#ffff00',false,false),
      new ColorInterval(-83,Infinity,'#00ff00',false,true),
    ]),
    new FlightInspectionCSVFields("Power Density Ratio","Power Density Ratio","dB","F",true ,false,false),
    new FlightInspectionCSVFields("DME Receiver Status Flag","DME Receiver Status Flag","","G",true, false,false),
    new FlightInspectionCSVFields("DME Distance","DME Distance","[NM]","H",true, false,false),
    new FlightInspectionCSVFields("DME Error","DME Error","[NM]","I",true, false,false),
    new FlightInspectionCSVFields("Reply Efficiency","Reply Efficiency","[%]","J",true, false,false),
    new FlightInspectionCSVFields("Elevation Angle","Elevation Angle","[Deg]","K",true, false,false),
    new FlightInspectionCSVFields("Heading","Heading","[Deg]","L",true, false,false),
    new FlightInspectionCSVFields("Calculated Slant Range","Calculated Slant Range","[NM]","M",true, false,false),
    new FlightInspectionCSVFields("User Defined 1","User Defined 1","","N",true, false,false),
    new FlightInspectionCSVFields("User Defined 2","User Defined 2","","O",true, false,false),
    new FlightInspectionCSVFields("User Defined 3","User Defined 3","","P",true, false,false),
    new FlightInspectionCSVFields("User Defined 4","User Defined 4","","Q",true, false,false),
    new FlightInspectionCSVFields("User Defined 5","User Defined 5","","R",true, false,false),
    new FlightInspectionCSVFields("Information","Information","","S",false, false,false),
  ];
 
  layerName:string;
  fileFormat = "CSV"
 
}
export class EDSConfiguration{
  fileConfiguration: FileConfiguration = new FileConfiguration(",",2,".",".", false,false,null);
  tableSoT: SoTTableElem[] = [
    new SoTTableElem(false, "Search",true),
    new SoTTableElem(false, "Track",true),
    new SoTTableElem(true, "Memory",true),
  ];
  tableFlags: FlagsTableElem[] = [
    new FlagsTableElem(false,"T","ExternalTriggered",true),
    new FlagsTableElem(false,"O","Overload condition",true),
    new FlagsTableElem(false,"I","Invalid condition",true),
    new FlagsTableElem(false,"U","Uncal condition",true),
    new FlagsTableElem(true,"P","Triggered by DME Pulse This indeicates that the dataset is initiated by a pulse; in this case the dataset time and GPS position belongs to the time of the outgoing pulse",true),
    new FlagsTableElem(true,"G","Synchronized with GPS. Dataset time is generated from GPS time; otherwise the PC clock is used",true),
    new FlagsTableElem(true,"D","DME detector active",true),
    new FlagsTableElem(false,"S","PPS Sync OK",true),
    new FlagsTableElem(true,"R","DME Pulses Detected. Indicates that DME pulses were received in the 4ms response window of the trigger pulse. Only present on P-messages",true),
  ];
  fieldsConfigurationTable : FlightInspectionCSVFields[] = [
    new FlightInspectionCSVFields("latitude","latitude","[Deg]","T",false,true),
    new FlightInspectionCSVFields("longitude","longitude","[Deg]","U",false,true),
    new FlightInspectionCSVFields("altitude","altitude","[m]","V",true,false,true,[
      new ColorInterval(-Infinity, 3000,'#ff0000',true, false),
      new ColorInterval(3000, 6000, '#ffa500'),
      new ColorInterval(6000, 10000, '#ffff00'),
      new ColorInterval(10000, 20000, '#008000'),
      new ColorInterval(20000, Infinity, '#0000ff',false,true)
    ]),
    new FlightInspectionCSVFields("Ctr","Ctr","[N/A]","A",true,false,false),
    new FlightInspectionCSVFields("MDME","MDME","[N/A]","B",true,false,true),
    new FlightInspectionCSVFields("Flags","Flags","[N/A]","C",true,false,true),
    new FlightInspectionCSVFields("dTime","dTime","[ms]","F",true,false,false),
    new FlightInspectionCSVFields("Freq","Freq","[MHz]","G",true,false,true),
    new FlightInspectionCSVFields("PeakLevel","PeakLevel","[dBm]","H",true,false,true,[
      new ColorInterval(-Infinity,-81,'#ff0000',true,false),
      new ColorInterval(-81,-78,'#ffa500',false,false),
      new ColorInterval(-78,-75,'#FFFF00',false,false),
      new ColorInterval(-75,Infinity,'#00FF00',false,true),
    ]),
    new FlightInspectionCSVFields("DeltaFreq","DeltaFreq","[kHz]","I",true,false,true),
    new FlightInspectionCSVFields("PulseSpacing","PulseSpacing","[uS]","J",true,false,false),
    new FlightInspectionCSVFields("ID_ON","ID_ON","N/A","K",true,false,true),
    new FlightInspectionCSVFields("ID_CODE","ID_CODE","N/A","L",true,false,true),
    new FlightInspectionCSVFields("DELAY","DELAY","[uS]","M",true,false,false),
    new FlightInspectionCSVFields("Dist","Dist","[km]","N",true,false,true),
    new FlightInspectionCSVFields("RepEff","RepEff","[%]","O",true,false,false),
    new FlightInspectionCSVFields("DMESpeed","DMESpeed","[m/s]","P",true,false,true),
    new FlightInspectionCSVFields("DstPred","DstPred","uS","R",true,false,false),
    new FlightInspectionCSVFields("PredWind","PredWind","uS","S",true,false,false),
    new FlightInspectionCSVFields("Speed","Speed","[km]","W",true,false,false),
    new FlightInspectionCSVFields("Satelites","Satelites","[km]","X",true,false,true),
    new FlightInspectionCSVFields("GPSfix","GPSfix","[km]","Y",true,false,false),
    new FlightInspectionCSVFields("SOT","SOT","","Q",true,false,true),
  ];
  navaid: string = "TIS-VOR_DME-LF";
  mdmeChannel: number = 1;
  filter: Filter = new Filter();
  layerName:string;
  fileFormat = "EDS";
 
}
export class AerodataConfig{
  fileConfiguration: FileConfiguration = new FileConfiguration(null,25,".",".",false,false,null);
 
  channels: Channel[] = [
    new Channel(true,"SIO-VOR_DME-LS"),
    new Channel(false,"VIT-DME-LB"),
    new Channel(false,"TACAN1"),
    new Channel(false,"TACAN2")
  ];
  //hasStyle required check
  fieldsConfigurationTable:  FlightInspectionCSVFields[] = [
    new FlightInspectionCSVFields("latitude","latitude","[Deg]","6",false,true),
    new FlightInspectionCSVFields("longitude","longitude","[Deg]","8",false,true),
    new FlightInspectionCSVFields("Altitude","Altitude","[ft]","10",true,false,true,[
      new ColorInterval(-Infinity, 3000,'#ff0000',true, false),
      new ColorInterval(3000, 6000, '#ffa500'),
      new ColorInterval(6000, 10000, '#ffff00'),
      new ColorInterval(10000, 20000, '#008000'),
      new ColorInterval(20000, Infinity, '#0000ff',false,true)
    ]),
    new FlightInspectionCSVFields("refposGPSTime","refposGPSTime","[s]","4",true,false,true),
    new FlightInspectionCSVFields("refposAltMSL","refposAltMSL","[ft]","12",true,false,true),
    new FlightInspectionCSVFields("refosBank","refosBank","[º]","14",true,false,true),
    new FlightInspectionCSVFields("refposPitch","refposPitch","[º]","16",true,false,true),
    new FlightInspectionCSVFields("refposTHdg","refposTHdg","[º]","18",true,false,true),
    new FlightInspectionCSVFields("refposEPE","refposEPE","[m]","20",true,false,true),
  ];
  channel1: FlightInspectionCSVFields[] = [
    new FlightInspectionCSVFields("dme1FluxDens","dme1FluxDens","[dbW/m2]","22",true, false,true,[
      new ColorInterval(-Infinity,-89,"#ff0000",true,false),
      new ColorInterval(-89,-86,'#ffa500'),
      new ColorInterval(-86,-83,'#ffff00'),
      new ColorInterval(-83,Infinity,'#008000',false,true),
    ]),
    new FlightInspectionCSVFields("dme1RepRate","dme1RepRate","[%]","24",true, false,false),
    new FlightInspectionCSVFields("dme1Frequency","dme1Frequency","[MHz]","26",true, false,false),
    new FlightInspectionCSVFields("dme1DistanceStatus","dme1DistanceStatus","","28",true, false,false),
    new FlightInspectionCSVFields("dme1ErrRng","dme1ErrRng","[NM]","30",true, false,true),
  ];
  channel2: FlightInspectionCSVFields[] = [
    new FlightInspectionCSVFields("dme2FluxDens","dme2FluxDens","[dbW/m2]","32",true, false,true,[
      new ColorInterval(-Infinity,-89,"#ff0000",true,false),
      new ColorInterval(-89,-86,'#ffa500'),
      new ColorInterval(-86,-83,'#ffff00'),
      new ColorInterval(-83,Infinity,'#00FF00',false,true),
    ]),
    new FlightInspectionCSVFields("dme2RepRate","dme2RepRate","[%]","34",true, false,false),
    new FlightInspectionCSVFields("dme2Frequency","dme2Frequency","[MHz]","36",true, false,false),
    new FlightInspectionCSVFields("dme2DistanceStatus","dme2DistanceStatus","","38",true, false,false),
    new FlightInspectionCSVFields("dme2ErrRng","dme2ErrRng","[NM]","40",true, false,true),
  ];
  channel3: FlightInspectionCSVFields[] =[
    new FlightInspectionCSVFields("tac1Frequency","tac1Frequency","[MHz]","42",true, false,true),
    new FlightInspectionCSVFields("tacan1FluxDens","tacanFluxDens","[dBW/m2]","44",true, false,true,
    [
      new ColorInterval(-Infinity,-89,"#ff0000",true,false),
      new ColorInterval(-89,-86,'#ffa500'),
      new ColorInterval(-86,-83,'#ffff00'),
      new ColorInterval(-83,Infinity,'#00FF00',false,true),
    ]
    ),
    new FlightInspectionCSVFields("tacan1RepRate","tacan1RepRate","[%]","46",true, false,true),
    new FlightInspectionCSVFields("tacan1Status","tacan1Status","","48",true, false,true),
    new FlightInspectionCSVFields("tacan1ErrRng","tacan1ErrRng","[NM]","50",true, false,true),
  ];
  channel4: FlightInspectionCSVFields[] =[
    new FlightInspectionCSVFields("freqTac2","freqTac2","[MHz]","52",true, false,false),
    new FlightInspectionCSVFields("tacan2FluxDens","tacan2FluxDens","[dBW/m2]","54",true, false,true,
    [
      new ColorInterval(-Infinity,-89,"#ff0000",true,false),
      new ColorInterval(-89,-86,'#ffa500'),
      new ColorInterval(-86,-83,'#ffff00'),
      new ColorInterval(-83,Infinity,'#00FF00',false,true),
    ]),
    new FlightInspectionCSVFields("tacan2RepRate","tacan2RepRate","[%]","56",true, false,false),
    new FlightInspectionCSVFields("tacan2Status","tacan2Status","","58",true, false,false),
    new FlightInspectionCSVFields("tacan2ErrRng","tacan2ErrRng","[dBW/m2]","60",true, false,true),
  ];
  layerName:string;
  fileFormat = "Aerodata";
}
export class Channel{
  constructor(
    public checked: boolean,
    public channelName:string
  ){
 
  }
 
}
export class Filter{
  constructor(
    public sotFilter: boolean = false,
      public flagsFilter: boolean = false
    ) {}
}